module.exports = __webpack_public_path__ + "img/hohlschnitt_feuerrot_ral3000.94b91a19.jpg";